import { Typography } from '@mui/material';
import { Stack } from '@mui/material';
import React from 'react';
import UserAvatar from '../../../../common/UserAvatar';
import { variants } from '../../../../variants/variants';
import { format } from 'date-fns';
import { ArrowRightAltRounded } from '@mui/icons-material';
import { useTheme } from '@emotion/react';
import { useMediaQuery } from '@mui/material';

const CandidateOverview = ({ formDetails }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme => theme.breakpoints.down('lg'));
  return (
    <Stack
      direction={isMobile ? 'column' : 'row'}
      justifyContent={'space-between'}
      sx={{ border: 1, p: 2, my: 1, borderColor: 'divider', borderRadius: variants.boxRadius.MAIN }}
    >
      {/* candidate details */}
      <Stack alignItems={'center'}>
        <Typography sx={{ mb: 1, fontSize: variants.BODY }}>Candidate</Typography>

        <UserAvatar src={formDetails?.employeeDetails?.employeePhotoPath} />
        <Typography sx={{ fontSize: variants.BODY, fontWeight: 600 }}>
          {formDetails?.employeeDetails?.empName} ({formDetails?.employeeDetails?.empCode})
        </Typography>
        <Typography sx={{ fontSize: variants.BODY }}>{formDetails?.employeeDetails?.techStack}</Typography>
      </Stack> 

      {/* jury details */}
      <Stack justifyContent={'flex-end'} alignItems={'center'}>
        <Typography sx={{ mb: 1, fontSize: variants.BODY }}>Meeting details</Typography>

        <Stack direction={'row'}>
          {formDetails?.interviewDetails
            ? formDetails?.interviewDetails?.juryDetails?.map((member, index) => {
                return (
                  <Stack direction={'row'} key={index} alignItems={'center'} sx={{ m: 1 }}>
                    <UserAvatar src={member.employeePhotoPath} sx={{ width: 30, height: 30 }} />
                    <Typography sx={{ fontSize: variants.TINY, ml: 1 }}>{member.empName}</Typography>
                  </Stack>
                );
              })
            : formDetails?.juryDetails?.map((member, index) => {
                return (
                  <Stack direction={'row'} key={index} alignItems={'center'} sx={{ m: 1 }}>
                    <UserAvatar src={member.employeePhotoPath} sx={{ width: 30, height: 30 }} />
                    <Typography sx={{ fontSize: variants.TINY, ml: 1 }}>{member.empName}</Typography>
                  </Stack>
                );
              })}
        </Stack>
        <Typography sx={{ fontSize: variants.BODY }}>
          {format(
            new Date(formDetails?.juryMeetingDate || formDetails?.interviewDetails?.juryMeetingDate || null),
            'PPpp'
          )}
        </Typography>
        <Stack
          direction={'row'}
          alignItems={'center'}
          sx={{
            border: 0,
            // ml: 'auto',
            [theme.breakpoints.down('lg')]: {
              mx: 'auto',
            },
          }}
        >
          <Typography sx={{ fontSize: variants.BODY }}>{formDetails?.currentDesignation?.split(' - ')[0]}</Typography>
          <ArrowRightAltRounded />
          <Typography sx={{ fontSize: variants.BODY }}>{formDetails?.desiredDesignation?.split(' - ')[0]}</Typography>
        </Stack>
      </Stack>

      {/* reporting head details */}
      <Stack alignItems={'center'}>
        <Typography sx={{ mb: 1, fontSize: variants.BODY }}>Delivery Head</Typography>
        <UserAvatar src={formDetails?.employeeDetails?.deliveryHeadDetails?.employeePhotoPath} />
        <Typography sx={{ fontSize: variants.BODY, fontWeight: 600 }}>
          {formDetails?.employeeDetails?.deliveryHeadDetails?.empName} (
          {formDetails?.employeeDetails?.deliveryHeadDetails?.empCode})
        </Typography>
      </Stack>
    </Stack>
  );
};

export default CandidateOverview;
